import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '电影', path: '/category/movie' },
  { name: '电视剧', path: '/category/tv' },
  { name: '综艺', path: '/category/variety' },
  { name: '动漫', path: '/category/anime' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-display text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-white'}`}>
              糖豆视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-500 text-background-50'
                    : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className={`w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
                  : 'text-white/70 hover:text-white hover:bg-white/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            type="button"
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}